module.exports = __webpack_public_path__ + "images/125_2048.jpg";